import React, { useContext, PropsWithChildren, JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import { NavSearchContext } from '../../context/NavSearchContext';
import { SearchBarVariant } from '../NavSearchElements/searchUtils';

export interface AutoSuggestDropdownProps {
    show?: boolean;
    id?: string;
    className?: string;
    useNewSearchUI?: boolean;
    useWarpSearchUI?: boolean;
}

const searchBarVariantStyle = {
    [SearchBarVariant.ProminentSearch]: 'w-max rounded-3xl p-6 mt-5 border border-gray-400 border-solid',
    [SearchBarVariant.ProminentSearchHistoryExperiment]:
        'w-max rounded-3xl p-6 mt-5 border border-gray-400 border-solid mt-4 -ml-5 lg:w-[720px] md:w-[500px]',
};

const AutoSuggestDropdown = ({
    className = '',
    show = false,
    children,
    useNewSearchUI,
    useWarpSearchUI = false,
    ...rest
}: PropsWithChildren<AutoSuggestDropdownProps>): JSX.Element | false => {
    const context = useContext(NavSearchContext);
    const { searchBarVariant } = context;
    const commonClassName = 'flex bg-white text-gray-900 shadow-dropdown absolute left-0 top-full z-50';

    return (
        show && (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions -- mousedown only keeps focus in the input
            <div
                className={twMerge(
                    commonClassName,
                    searchBarVariantStyle[searchBarVariant as keyof typeof searchBarVariantStyle] ??
                        (useWarpSearchUI
                            ? 'rounded-3xl border border-gray-400 border-solid mt-8 px-3 py-6'
                            : 'rounded-b pb-1.5'),
                    className,
                )}
                onMouseDown={(e) => e.preventDefault()}
                {...rest}
            >
                {children}
            </div>
        )
    );
};

export default AutoSuggestDropdown;
